var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sa-table"},[_vm._t("table"),_c('div',[_vm._t("pagination")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }